import { setFeatures } from '@/utils/feature.helper'
import { authService } from '../../helpers/services/auth.service';
import router from '../../router/index'
import { sessionHelper, sharedHelper } from '@/utils'
import { SESSION } from '@/constants'
import i18n from '@/i18n'

const user = JSON.parse(localStorage.getItem('user'));
const staff = JSON.parse(localStorage.getItem('staffUser'));
export const state = user
    ? { status: { loggeduser: true }, user, staff }
    : { status: {}, user: null, staff: null };

export const MODULE = 'auth'; 

// define action 
export const LOGIN = 'login'; 
export const RESET_PASSWORD = 'resetPassword'; 
export const UPDATE_PASSWORD = 'updatePassword'; 
export const LOGOUT = 'logout';
export const REFRESH_TOKEN = 'refreshToken'; 

export const STAFF_LOGIN = 'staffLogin'; 
export const STAFF_RESET_PASSWORD = 'staffResetPassword'; 
export const STAFF_UPDATE_PASSWORD = 'staffUpdatePassword'; 
export const STAFF_LOGOUT = 'staffLogout';
export const STAFF_REFRESH_TOKEN = 'staffRefreshToken'; 

// define mutation
const REQUESTING = "requesting";
const LOGIN_SUCCESS = "loginSuccess";
const LOGOUT_SUCCESS = "logout";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REFRESH_TOKEN_SUCCESS = "refreshTokenSuccess";
const STAFF_LOGIN_SUCCESS = "staffLoginSuccess";
const STAFF_LOGOUT_SUCCESS = "staffLogout";
const STAFF_REFRESH_TOKEN_SUCCESS = "staffRefreshTokenSuccess";
const STAFF_SUCCESS = "staffSuccess";

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.user
    },
    staffLoggedIn(state) {
        return !!state.staff
    },
}

export const actions = {

    async [LOGIN] ({ commit }, { data }) {
        commit(REQUESTING);
        authService.login(data).then(
            user => {
                commit(LOGIN_SUCCESS, user);  
            },
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        )
    },
    async [LOGOUT] ({ commit }) {
        commit(LOGOUT_SUCCESS);
        let message = i18n.t("message.logoutSuccess");
        sharedHelper.alertSuccessMessage(message);
        commit(SUCCESS);
    },

    async [REFRESH_TOKEN] ({ commit }) {
        commit(REQUESTING);
        await authService.refreshToken().then(
            
            // eslint-disable-next-line no-unused-vars
            user => {
                commit(REFRESH_TOKEN_SUCCESS, user);
            }, 
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        );
    },
    [RESET_PASSWORD] ({ commit }, { data }) {
        commit(REQUESTING);
        authService.resetPassword(data).then(
            // eslint-disable-next-line no-unused-vars
            result => {
                let message = i18n.t("message.checkYourEmailForResetPassword");
                sharedHelper.alertSuccessMessage(message)
                commit(SUCCESS);
            },
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        )
    },
    [UPDATE_PASSWORD] ({ commit }, { data }) {
        commit(REQUESTING);
        authService.updatePassword(data).then(
            // eslint-disable-next-line no-unused-vars
            result => {
                let message = i18n.t("message.updateXSuccess", [i18n.t('label.password')]);
                sharedHelper.alertSuccessMessage(message)
                commit(SUCCESS);
            },
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        )
    },
    async [STAFF_LOGIN] ({ commit }, { data }) {
        commit(REQUESTING);
        authService.staffLogin(data).then(
            user => {
                commit(STAFF_LOGIN_SUCCESS, user);  
            },
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        )
    },
    async [STAFF_LOGOUT] ({ commit }) {
        commit(STAFF_LOGOUT_SUCCESS);
        let message = i18n.t("message.logoutSuccess");
        sharedHelper.alertSuccessMessage(message);
        commit(STAFF_SUCCESS);
    },

    async [STAFF_REFRESH_TOKEN] ({ commit }) {
        commit(REQUESTING);
        await authService.staffRefreshToken().then(
            
            // eslint-disable-next-line no-unused-vars
            user => {
                commit(STAFF_REFRESH_TOKEN_SUCCESS, user);
            }, 
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        );
    },
    [STAFF_RESET_PASSWORD] ({ commit }, { data }) {
        commit(REQUESTING);
        authService.staffResetPassword(data).then(
            // eslint-disable-next-line no-unused-vars
            result => {
                let message = i18n.t("message.checkYourEmailForResetPassword");
                sharedHelper.alertSuccessMessage(message)
                commit(STAFF_SUCCESS);
            },
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        )
    },
    [STAFF_UPDATE_PASSWORD] ({ commit }, { data }) {
        commit(REQUESTING);
        authService.staffUpdatePassword(data).then(
            // eslint-disable-next-line no-unused-vars
            result => {
                let message = i18n.t("message.updateXSuccess", [i18n.t('label.password')]);
                sharedHelper.alertSuccessMessage(message)
                commit(STAFF_SUCCESS);
            },
            error => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error.response.data.code)
                commit(FAILURE, error);
            }
        )
    },
};

export const mutations = {
    [REQUESTING](state) {
        state.status = { processing: true };
    },
    [SUCCESS](state) {
        state.status = {};
        router.push('/login');      
    },
    [STAFF_SUCCESS](state) {
        state.status = {};
        router.push('/staff-login');      
    },
    [FAILURE](state) {
        state.status = {};
    },
    [LOGIN_SUCCESS](state, user) {
        state.status = { loggeduser: true };
        state.user = user;

        var tokenExpiredTime = sessionHelper.calculateTime(user.data.token.expires_in)
        var refreshTokenExpiredTime = sessionHelper.calculateTime(user.data.token.refresh_expires_in) 

        localStorage.setItem(SESSION.USER_ID, user.data.user.uuid)
        localStorage.setItem(SESSION.USER_EMAIL, user.data.user.email)
        localStorage.setItem(SESSION.USER_NAME, user.data.user.name)
        localStorage.setItem(SESSION.JWT_TOKEN, user.data.token.access_token)
        localStorage.setItem(SESSION.TOKEN_EXPIRY_TIME, tokenExpiredTime)
        localStorage.setItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME, refreshTokenExpiredTime)
        localStorage.setItem(SESSION.PERMISSIONS, JSON.stringify(user.data.user.permissions || []))
        setFeatures(user.data.features || {})
        localStorage.setItem(SESSION.USER, JSON.stringify(user));
        localStorage.setItem(SESSION.USER_TYPE, 'ADMIN');

        router.push('/');
    },
    [LOGOUT_SUCCESS](state) {
        sessionHelper.clearAllClientStorage()
        state.status = {};
        state.user = null;
    },
    [REFRESH_TOKEN_SUCCESS](state, user) {
        state.status = {};

        var tokenExpiredTime = sessionHelper.calculateTime(user.data.token.expires_in) 
        var refreshTokenExpiredTime = sessionHelper.calculateTime(user.data.token.refresh_expires_in) 

        localStorage.setItem(SESSION.USER_ID, user.data.user.uuid)
        localStorage.setItem(SESSION.USER_EMAIL, user.data.user.email)
        localStorage.setItem(SESSION.USER_NAME, user.data.user.name)
        localStorage.setItem(SESSION.JWT_TOKEN, user.data.token.access_token)
        localStorage.setItem(SESSION.TOKEN_EXPIRY_TIME, tokenExpiredTime)
        localStorage.setItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME, refreshTokenExpiredTime)
        localStorage.setItem(SESSION.PERMISSIONS, JSON.stringify(user.data.user.permissions || []))
        setFeatures(user.data.features || {})
        localStorage.setItem(SESSION.USER, JSON.stringify(user));

    },
    [STAFF_LOGIN_SUCCESS](state, user) {
        state.status = { loggeduser: true };
        state.staff = user;

        var tokenExpiredTime = sessionHelper.calculateTime(user.data.token.expires_in) 
        var refreshTokenExpiredTime = sessionHelper.calculateTime(user.data.token.refresh_expires_in) 

        localStorage.setItem(SESSION.STAFF_USER_ID, user.data.staff.uuid)
        localStorage.setItem(SESSION.STAFF_USER_EMAIL, user.data.staff.email)
        localStorage.setItem(SESSION.STAFF_USER_NAME, user.data.staff.first_name + ' ' + user.data.staff.last_name)
        localStorage.setItem(SESSION.STAFF_JWT_TOKEN, user.data.token.access_token)
        localStorage.setItem(SESSION.STAFF_USER_IMAGE, user.data.staff.display_image_url)
        localStorage.setItem(SESSION.STAFF_TOKEN_EXPIRY_TIME, tokenExpiredTime)
        localStorage.setItem(SESSION.STAFF_REFRESH_TOKEN_EXPIRY_TIME, refreshTokenExpiredTime)
        // localStorage.setItem(SESSION.PERMISSIONS, JSON.stringify(user.data.user.roles[0].permissions))
        localStorage.setItem(SESSION.STAFF_USER, JSON.stringify(user));
        localStorage.setItem(SESSION.USER_TYPE, 'STAFF');
        localStorage.setItem(SESSION.STAFF_COMPANY_NAME, user.data.staff.location.company.name)
        localStorage.setItem(SESSION.STAFF_COMPANY_UUID, user.data.staff.location.company.uuid)
        localStorage.setItem(SESSION.STAFF_LOCATION_NAME, user.data.staff.location.name)
        localStorage.setItem(SESSION.STAFF_LOCATION_UUID, user.data.staff.location.uuid)
    
        router.push('/');      
    },
    [STAFF_LOGOUT_SUCCESS](state) {
        sessionHelper.clearAllClientStorage()
        state.status = {};
        state.staff = null;
    },
    [STAFF_REFRESH_TOKEN_SUCCESS](state, user) {
        state.status = {};

        var tokenExpiredTime = sessionHelper.calculateTime(user.data.token.expires_in) 
        var refreshTokenExpiredTime = sessionHelper.calculateTime(user.data.token.refresh_expires_in) 

        localStorage.setItem(SESSION.STAFF_USER_ID, user.data.staff.uuid)
        localStorage.setItem(SESSION.STAFF_USER_EMAIL, user.data.staff.email)
        localStorage.setItem(SESSION.STAFF_USER_NAME, user.data.staff.first_name + ' ' + user.data.staff.last_name)
        localStorage.setItem(SESSION.STAFF_JWT_TOKEN, user.data.token.access_token)
        localStorage.setItem(SESSION.STAFF_TOKEN_EXPIRY_TIME, tokenExpiredTime)
        localStorage.setItem(SESSION.STAFF_USER_IMAGE, user.data.staff.display_image_url)
        localStorage.setItem(SESSION.STAFF_REFRESH_TOKEN_EXPIRY_TIME, refreshTokenExpiredTime)
        // localStorage.setItem(SESSION.PERMISSIONS, JSON.stringify(user.data.user.roles[0].permissions))
        localStorage.setItem(SESSION.STAFF_USER, JSON.stringify(user));

    },
};

